<template>
    <div style="display: contents">

        <!-- Search Input -->
        <form>
            <input id="search-text-input"
                   type="text"
                   @keyup="search()"
                   ref="searchInput"
                   v-model="form.searchKey"
                   placeholder="Enter Search Term"/>
            <button type="submit" disabled>
                <svg class="return"><use xlink:href="#return"></use></svg>
            </button>
        </form>

        <!--Search Results on Search -->
        <div class="search-results">

            <div v-if="!isDirty" class="search-results__top">
                <h2>Featured</h2>
            </div>

            <!-- Results Tabs -->
            <div v-else class="search-results__top">

                <div v-if="results"  class="tabs" :style="tabStyle">

                    <button class="search-tab-trigger"
                            v-if="results.spots.nbHits"
                            @click="tabShow('spots')"
                            :class="{ 'active' : showingTab == 'spots' }"
                            data-tar="spots">
                        Spots
                        <span v-text="`(${results.spots.nbHits})`"></span>
                    </button>
                    <button class="search-tab-trigger"
                            v-if="results.members.nbHits"
                            @click="tabShow('members')"
                            :class="{ 'active' : showingTab == 'members' }"
                            data-tar="members">
                        Members
                        <span v-text="`(${results.members.nbHits})`"></span>
                    </button>

<!--                    <button class="search-tab-trigger"-->
<!--                            v-if="results.tags.nbHits"-->
<!--                            @click="tabShow('tags')"-->
<!--                            :class="{ 'active' : showingTab == 'tags' }"-->
<!--                            data-tar="tags">-->
<!--                        Tags-->
<!--                    </button>-->

                    <button class="search-tab-trigger"
                            v-if="results.lists.nbHits"
                            @click="tabShow('lists')"
                            :class="{ 'active' : showingTab == 'lists' }"
                            data-tar="lists">
                        Lists
                        <span v-text="`(${results.lists.nbHits})`"></span>
                    </button>

                    <button class="search-tab-trigger"
                            v-if="results.posts.nbHits"
                            @click="tabShow('posts')"
                            :class="{ 'active' : showingTab == 'posts' }"
                            data-tar="journal">
                        Journal
                        <span v-text="`(${results.posts.nbHits})`"></span>
                    </button>
                </div>
            </div>

            <div class="search-results__tab-results" v-if="results">

                <div class="search-results__tab-result active" v-if="showingTab == 'spots'">

                    <!-- Feature Members -->
                    <sidebar-results v-if="!isDirty"
                                     :data="results.members.hits"
                                     :limit="3"
                                     type="members" />

                    <!-- Feature Cities -->
                    <sidebar-results
                                     :data="results.cities.hits"
                                     :limit="3"
                                     type="cities"/>

                    <!-- Feature Spots -->
                    <spot-results :limit="(isDirty ? null : 3)" :data="results.spots.hits" />

                </div>

                <!-- Members -->
                <div class="search-results__tab-result active"
                     v-if="showingTab == 'members'">
                    <sidebar-results :data="results.members.hits" type="members" />
                </div>

                <!-- Tags -->
<!--                <div class="search-results__tab-result active"-->
<!--                     v-if="showingTab == 'tags'">-->
<!--                    <sidebar-results :data="results.tags.hits" type="tags" />-->
<!--                </div>-->

                <!-- Lists -->
                <div class="search-results__tab-result active"
                     v-if="showingTab == 'lists'">
                    <sidebar-results :data="results.lists.hits" type="lists" />
                </div>

                <!-- Posts -->
                <div class="search-results__tab-result active"
                     v-if="showingTab == 'posts'">
                    <sidebar-results :data="results.posts.hits" type="posts" />
                </div>

            </div>

        </div>

        <div id="js-search-modal"></div>

    </div>
</template>
<script>

import SpotResults from './SpotResults'
import SidebarResults from './SidebarResults'
import MemberModal from './MemberModal'

export default {

    components: {
        SpotResults,
        SidebarResults,
        MemberModal
    },

    data() {
        return {
            form: {
                searchKey: '',
            },
            results: null,
            isDirty: false,
            isActive: false,
            showingTab: 'spots',
            tabStyle: {
                gridTemplateColumns: '1fr 1fr 1fr  1fr 1fr'
            }
        }
    },

    mounted() {
        $('.search-trigger').on('click', () => {
            this.search()
            this.$nextTick(() => {
                this.$refs.searchInput.focus()
            })
        })
    },

    methods: {

        search: _.debounce(function () {

            this.isDirty = this.form.searchKey.trim() != ""

            axios.get(`/search`, {
                params: this.form
            })
                .then(response => {
                    this.results = response.data

                    let showing = _.pickBy(this.results, (r, key) => {
                        return r.nbHits && key != 'cities'
                    })

                    // Jump to first active tab
                    let keys = Object.keys(showing);
                    let first  = keys[0]
                    if(!first) return
                    this.showingTab = first

                    // we do this because we are not using tags on the search
                    let repeat = keys.includes('tags') ? keys.length - 1 : keys.length;

                    // Update tab style
                    this.tabStyle = {
                        gridTemplateColumns: '1fr '.repeat(repeat)
                    }
                })
                .catch(error => {
                    console.error("Search Error...")
                })
        }, 500),

        tabShow(tab) {
            this.showingTab = tab
        },
    }
}
</script>